import { ColumnDef } from '@tanstack/react-table'
import { useTranslations } from '@/hooks/useTranslations'
import { useMemo } from 'react'

import { UserDropdown, UserStatus } from '@/constants/user'
import { useLanguage } from '@/hooks'
import * as DateUtil from '@/utils/date'
import { formatNumber, formatTableNumber } from '@/utils/number'

import { ActionDropdown } from './ActionDropdown'
import { StatusBadge } from '@/components/common/Badge/Status'
import { Customer } from '@/models/customer/customer'

type UseDatatableHeadersProps = {
  search: string
  onClickBillDropdownEvent: (eventName: UserDropdown, data: Customer) => void
}

export function useDatatableHeaders({ search, onClickBillDropdownEvent }: UseDatatableHeadersProps) {
  const t = useTranslations('admin.customer_management.table')

  const { locale } = useLanguage()

  const columns = useMemo(() => {
    const columnsRender: (ColumnDef<Customer> & { sticky?: 'left' | 'right' })[] = [
      {
        id: 'no',
        header: t('no'),
        cell: (ctx) => (
          <div className="text-start">
            {formatTableNumber({
              index: ctx.row.index + 1,
              pageSize: ctx.table.getState().pagination.pageSize,
              pageIndex: ctx.table.getState().pagination.pageIndex,
            })}
          </div>
        ),
        size: 60,
        enableSorting: false,
      },
      {
        id: 'name_name',
        header: t('name'),
        cell: (ctx) => ctx.row.original?.name ?? "-",
        size: 160,
        enableSorting: false,
      },
      {
        id: 'phone',
        header: t('phone'),
        cell: (ctx) => ctx.row.original?.phone_number ?? "-",
        size: 160,
        enableSorting: false,
      },
      {
        id: 'car_registration',
        header: t('car_registration'),
        cell: (ctx) => ctx.row.original?.car_registration ?? "-",
        size: 160,
        enableSorting: false,
      },
      {
        id: 'created_at',
        header: t('created_at'),
        cell: (ctx) => DateUtil.formatDate(ctx.row.original?.created_at ?? "-", DateUtil.DateFormat.DATE_TIME, locale),
        size: 160,
        enableSorting: true,
      },
      {
        id: 'updated_at',
        header: t('updated_at'),
        cell: (ctx) => DateUtil.formatDate(ctx.row.original?.updated_at ?? "-", DateUtil.DateFormat.DATE_TIME, locale),
        size: 160,
        enableSorting: true,
      },
      // {
      //   id: 'action',
      //   header: '',
      //   cell: (ctx) => (
      //     <ActionDropdown
      //       status={UserStatus.ACTIVE}
      //       onClickDropdownItem={(eventName) => onClickBillDropdownEvent(eventName, ctx.row.original)}
      //     />
      //   ),
      //   size: 60,
      //   enableSorting: false,
      // },
    ]
    return columnsRender
  }, [locale, t, search, onClickBillDropdownEvent])

  return { columns }
}
